define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools"], function (require, exports, $, ko, log, urls_1, tools) {
    "use strict";
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    var ResetPassword = /** @class */ (function () {
        function ResetPassword() {
            this.Email = ko.observable();
            this.Password = ko.observable();
            this.ConfirmPassword = ko.observable();
            this.Code = ko.observable();
            this.ConfirmCode = ko.observable();
            this.HasError = ko.observable(false);
            this.Error = ko.observable();
            this.HasNotification = ko.observable(false);
            this.Notification = ko.observable();
        }
        ResetPassword.prototype.init = function () {
            var self = this;
            self.Code(urls_1.urls.getQueryString("code"));
            self.ConfirmCode(urls_1.urls.getQueryString("confirmCode"));
            ko.applyBindings(self, document.getElementById("ko-main-content"));
        };
        ResetPassword.prototype.doChangePassword = function () {
            var self = this;
            self.HasNotification(false);
            self.HasError(false);
            self.Error("");
            var obj = ko.mapping.toJS({
                Email: self.Email,
                Password: self.Password,
                ConfirmPassword: self.ConfirmPassword,
                Code: self.Code,
                ConfirmCode: self.ConfirmCode
            });
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            if (!regex.test(obj.Email) || !obj.Email) {
                self.HasError(true);
                self.Error("Please enter a valid email address.");
                return;
            }
            var passwordErrors = tools.validatePassword(obj.Password);
            if (passwordErrors) {
                self.HasError(true);
                self.Error(passwordErrors);
                return;
            }
            if (obj.Password !== obj.ConfirmPassword) {
                self.HasError(true);
                self.Error("Passwords does not match.");
                return;
            }
            $(".js-login").button("loading");
            tools.ajaxPost({
                url: "/Account/ResetPassword",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    window.location.href = "/Account/Login";
                }
                else {
                    if (result.Data && result.Error != null) {
                        self.Error(result.Error);
                    }
                    else {
                        self.Error("Unknown error occurred.");
                    }
                    self.HasError(true);
                    return;
                }
            }).always(function () {
                $(".js-login").button("reset");
            });
            ;
            return;
        };
        return ResetPassword;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Account/ResetPassword")) {
            log.log("Initialize reset password");
            $(function () {
                (new ResetPassword()).init();
            });
        }
    }, 0);
    return ResetPassword;
});
//# sourceMappingURL=resetPassword.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/account/resetPassword.js
// module id = 288
// module chunks = 2